<div class='accordion-item'>
  <h3 id='accordion-{{ id }}-heading'
       class='accordion-header'>
    <button class='accordion-button collapsed'
            type='button'
            attr.aria-controls='accordion-{{ id }}-panel'
            aria-expanded='false'
            data-bs-toggle='collapse'
            attr.data-bs-target='#accordion-{{ id }}-panel'>
      {{ accordionTitle }}
    </button>
  </h3>
  <section attr.aria-labelledby='accordion-{{ id }}-heading'
       class='accordion-collapse collapse'
       id='accordion-{{ id }}-panel'>
    <div class='accordion-body'>
      <ng-content></ng-content>
    </div>
  </section>
</div>
